/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  EstimateMeterReadRequest,
  EstimateMeterReadResponse,
  SubmitEstimatedMeterReadingRequest,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * Writes each reading to Junifer with source System and quality Estimated. The reading description is built from the caller's token email plus the optional calculation detail, capped at 1000 characters. An existing read on the same date is never replaced - the duplicate is returned as an error.
 * @summary Submit a Meter Read Estimator result as a System read, quality Estimated. Metering, Billing and Payments roles only.
 */
export const submitEstimatedMeterReading = (
  billingAccountId: number,
  submitEstimatedMeterReadingRequest: SubmitEstimatedMeterReadingRequest,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    {
      url: `/${billingAccountId}/meterReading/estimated`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: submitEstimatedMeterReadingRequest,
    },
    options,
  )
}
/**
 * @summary Estimate a meter read for one or more registers at a target date
 */
export const estimateMeterRead = (
  estimateMeterReadRequest: EstimateMeterReadRequest,
  options?: SecondParameter<
    typeof backofficeRequest<EstimateMeterReadResponse>
  >,
) => {
  return backofficeRequest<EstimateMeterReadResponse>(
    {
      url: `/assets/meter-read/estimate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: estimateMeterReadRequest,
    },
    options,
  )
}
export type SubmitEstimatedMeterReadingResult = NonNullable<
  Awaited<ReturnType<typeof submitEstimatedMeterReading>>
>
export type EstimateMeterReadResult = NonNullable<
  Awaited<ReturnType<typeof estimateMeterRead>>
>
